import React from 'react';
export function Marquee() {
  const words = ['PRAYER', 'OUTREACH', 'MISSIONS', 'INTERCESSION', 'REVIVAL', 'PRAYER', 'OUTREACH', 'MISSIONS', 'INTERCESSION', 'REVIVAL'];
  return <div className="w-full bg-midnight py-4 overflow-hidden flex items-center border-y-4 border-gold" data-id="element-246">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-247">
        {/* Double the array to ensure seamless looping */}
        {[...words, ...words, ...words].map((word, i) => <div key={i} className="flex items-center" data-id="element-248">
            <span className="text-2xl md:text-3xl font-display font-bold text-ivory tracking-widest px-8" data-id="element-249">
              {word}
            </span>
            <span className="w-3 h-3 rounded-full bg-gold shrink-0" data-id="element-250" />
          </div>)}
      </div>
    </div>;
}